import React from "react";

export const WarningIcon = () => {
  return (
    <>
      <svg
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.83526 0.95728L0.271001 15.017C0.0944262 15.3177 0.000996629 15.6587 7.9294e-06 16.0059C-0.00098077 16.3531 0.0905058 16.6946 0.265366 16.9963C0.440226 17.2979 0.692364 17.5493 0.996696 17.7254C1.30103 17.9015 1.64694 17.9962 2.00003 18H19.1285C19.4816 17.9962 19.8275 17.9015 20.1319 17.7254C20.4362 17.5493 20.6883 17.2979 20.8632 16.9963C21.0381 16.6946 21.1296 16.3531 21.1286 16.0059C21.1276 15.6587 21.0341 15.3177 20.8576 15.017L12.2933 0.95728C12.1131 0.665054 11.8593 0.423446 11.5564 0.255768C11.2535 0.0880891 10.9118 0 10.5643 0C10.2167 0 9.87503 0.0880891 9.57217 0.255768C9.26931 0.423446 9.01551 0.665054 8.83526 0.95728Z"
          fill="#FECE72"
          style={{
            fill: "#FECE72",
            fill: "color(display-p3 0.9955 0.8090 0.4470)",
            fillOpacity: 1,
          }}
        />
        <path
          d="M10.5664 6.06836V10.0457"
          stroke="white"
          style={{ stroke: "white", strokeOpacity: 1 }}
          strokeWidth="2"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.5664 14.0234H10.5814"
          stroke="white"
          style={{ stroke: "white", strokeOpacity: 1 }}
          strokeWidth="2"
          strokeLinecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};
